import { Modal } from 'src/ui/molecules/modal';
import styled from 'styled-components';

interface DocumentModalProps {
  isImage?: boolean;
}

export const DocumentModal = styled(Modal)<DocumentModalProps>`
  width: 90%;
  height: ${(props) => (props.isImage ? 'auto' : '98%')};
  margin: auto;
  embed {
    width: 100%;
    min-height: ${(props) => (props.isImage ? 'auto' : 'calc(100vh - 15rem)')};
  }
`;
